import * as React from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

export interface GenericSearchWidgetProps {
    searchTerm: string
    placeholderText?: string
    changeSearchTerm: (value: string) => void
    isLoading?: boolean
}

interface InternalState {
    searchTerm: string,
    timerId?: number
}

export default class GenericSearchWidget extends React.Component<GenericSearchWidgetProps, InternalState> {
    constructor(props: GenericSearchWidgetProps) {
        super(props);
        this.state = {searchTerm: props.searchTerm}
    }

    changeSearchTerm(evt: React.SyntheticEvent<HTMLInputElement>) {
        if (this.state.timerId) 
            window.clearTimeout(this.state.timerId);

        const currentSearchTerm = evt.currentTarget.value;
        const timerId = window.setTimeout(() => {
            this.props.changeSearchTerm(currentSearchTerm)
        }, 500);

        this.setState({searchTerm: currentSearchTerm, timerId: timerId})
    }

    render() {
        const isLoading = this.props.isLoading || false
        const placeholderText = this.props.placeholderText !== undefined 
            ? this.props.placeholderText
            : 'Search...';
        return <Input.Search
            placeholder={placeholderText}
            value={this.state.searchTerm}
            onChange={this.changeSearchTerm.bind(this)}
            prefix={<SearchOutlined />}
            allowClear
            loading={isLoading}
            style={{ width: '100%' }}
        />
    }
}
